import React, { useState } from 'react';
import { trackCallConversion } from '../utils/phone';

/**
 * Preserves the site's existing phone-link behavior: phones dial directly,
 * desktops copy the number to the clipboard and show a confirmation.
 */
export function usePhoneClick() {
  const [copied, setCopied] = useState(false);
  const onClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    trackCallConversion();
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    if (isMobile) return;
    e.preventDefault();
    navigator.clipboard.writeText('(818) 381-9905').then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }).catch(() => {
      window.location.href = 'tel:8183819905';
    });
  };
  return {
    onClick,
    copied
  };
}
